export default __webpack_public_path__ + "static/media/drone.b48e0f50.png";